import * as shared from 'pericles-shared'
import * as types from 'pericles-types'

export const updateChatStatus = shared.callFunction<
  types.UpdateChatStatusInput,
  types.DefaultResponse
>('updateChatStatus')
